// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimInternalNoteUpdateDto
 */
export interface IClaimInternalNoteUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimInternalNoteUpdateDto
     */
    note_text?: string;
}

/**
 * Check if a given object implements the IClaimInternalNoteUpdateDto interface.
 */
export function instanceOfIClaimInternalNoteUpdateDto(value: object): value is IClaimInternalNoteUpdateDto {
    return true;
}

export function IClaimInternalNoteUpdateDtoFromJSON(json: any): IClaimInternalNoteUpdateDto {
    return IClaimInternalNoteUpdateDtoFromJSONTyped(json, false);
}

export function IClaimInternalNoteUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimInternalNoteUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'note_text': json['note_text'] == null ? undefined : json['note_text'],
    };
}

export function IClaimInternalNoteUpdateDtoToJSON(json: any): IClaimInternalNoteUpdateDto {
    return IClaimInternalNoteUpdateDtoToJSONTyped(json, false);
}

export function IClaimInternalNoteUpdateDtoToJSONTyped(value?: IClaimInternalNoteUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'note_text': value['note_text'],
    };
}

